<template>
  <div class="flex h-screen w-screen flex-col lg:flex-row">
    <NavBar
      :login="handleLogin"
      :header-service="headerService"
      :nav-module-type="NAV_MENU_TYPE.HOME"
      @handle-upgrade="handleUpgrade"
    />
    <div class="flex flex-col h-full grow min-w-0">
      <FiveXCreditsBanner></FiveXCreditsBanner>
      <RouterView></RouterView>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useHeaderService } from '@/composables/use-header-service';
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { useLoginSdk } from './composables/use-loginsdk';
import { i18n } from '@/infrastructure/locales';
import { useTracking } from './composables/tracking/use-tracking';
import { useMseProducts } from './composables/home/use-product';
import FiveXCreditsBanner from './components/common/dialogs/FiveXCreditsBanner/FiveXCreditsBanner.vue';

const { headerService } = useHeaderService();
const { openLoginDialog } = useLoginSdk(i18n as any);
const { sendTracking } = useTracking();
const { usedProduct } = useMseProducts();

const handleLogin = () => {
  sendTracking('ss_plg_register', 'register_exposure', {
    registrationSource: `mse_${usedProduct.value.toLowerCase()}`,
  });
  openLoginDialog(false, false, () => {
    sendTracking('ss_plg_register', 'register_close', {
      registrationSource: `mse_${usedProduct.value.toLowerCase()}`,
    });
  });
};

const handleUpgrade = () => {
  sendTracking('ss_eureka_upgrade_page', 'upgrade_trigger', {
    product_line: 'eureka_mse',
    trigger_source: 'side_nav',
    agent_name: `mse_${usedProduct.value.toLowerCase()}`,
    page_url: window.location.href,
  });
};
</script>
